import styled from 'styled-components'
import { down } from 'styled-breakpoints'
import Wheel from './Wheel'

type IProps = {
  values: Array<string>
}

const StyledWheel = styled.div`
  .wheel {
    --top-margin: 2rem;
    display: block;
    overflow: visible;
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    margin-top: calc(var(--top-margin) * -2);

    ${down('lg')} {
      height: 300px;
    }

    ${down('md')} {
      height: 200px;
    }
  }

  .wheel--perspective-right .wheel__inner {
    perspective-origin: calc(50% + 250px) 50%;
    transform: translateX(10px);
    -webkit-transform: translateX(10px);
  }

  .wheel--perspective-left .wheel__inner {
    perspective-origin: calc(50% - 250px) 50%;
    transform: translateX(-10px);
    -webkit-transform: translateX(-10px);
  }

  .wheel__inner {
    display: flex;
    align-items: center;
    justify-content: center;
    perspective: 2000px;
    transform-style: preserve-3d;
    height: 16%;
    width: 100%;
    margin-top: var(--top-margin);
  }

  .wheel__slides {
    height: 100%;
    position: relative;
    width: 100%;
  }

  .wheel__shadow-top,
  .wheel__shadow-bottom {
    left: -8rem;
    height: 42%;
    width: 100%;
    position: relative;
    z-index: 5;

    &::after {
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.9) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
      content: '';
      position: absolute;
      display: block;
      height: 100%;
      width: 100vw;
    }
  }

  .wheel__shadow-top {
    &::after {
      top: 0;
    }
  }

  .wheel__shadow-bottom {
    margin-bottom: -3rem;

    &::after {
      bottom: 0;
    }
  }

  .wheel__slide {
    align-items: center;
    backface-visibility: hidden;
    height: 100%;
    width: 100%;
    position: absolute;
  }
`

const ScrolledSentecesWheel: React.FC<IProps> = ({ values }: IProps) => {
  const formateDate = (idx: number) => {
    return values[idx]
  }

  return (
    <StyledWheel>
      <div style={{ width: '100%' }}>
        <Wheel
          autoplay
          loop
          perspective="left"
          length={values.length}
          setValue={(i) => formateDate(i)}
        />
      </div>
    </StyledWheel>
  )
}

export default ScrolledSentecesWheel
